import React, { FC } from 'react';

import { Container, ContainerProps } from '@lglp/components';
import {
  LinkDocument,
  LinkType,
  MenuCta,
  MenuCtaScope,
} from '@lglp/prismic-client';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { RootState } from '../../../reducers';
import { LinkedComponent } from '../../LinkedComponent';
import styles from './MenuCtas.module.scss';

type MenuCtasProps = ContainerProps & { menuCtas: MenuCta[] };

export const MenuCtas: FC<MenuCtasProps> = ({ menuCtas, className }) => {
  const mainDocument = useSelector((state: RootState) => state.main?.document);
  const { pathname } = useLocation();

  const isActive = (menuCta: MenuCta) => {
    switch (menuCta?.activeOn) {
      case MenuCtaScope.Investors:
        return (
          pathname.startsWith('/fr/investisseurs') ||
          pathname.startsWith('/en/investors')
        );
      default:
        return (
          menuCta.cta?.link?.linkType === LinkType.Document &&
          (menuCta.cta?.link as LinkDocument).uid === mainDocument.uid
        );
    }
  };

  return (
    <>
      {menuCtas?.map((menuCta, i) => (
        <Container
          key={i}
          as="li"
          className={[
            styles.ctaMenu,
            i === 0 && 'firstMenuCta',
            isActive(menuCta) && 'selectedMenuCta',
            className,
          ]}
        >
          <LinkedComponent
            link={menuCta.cta.link}
            className={[styles.ctaMenuLink]}
          >
            {menuCta.cta.label}
          </LinkedComponent>
        </Container>
      ))}
    </>
  );
};
